/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest } from "../../authConfig"
import { APP_NAME,CLIENT_CODE,RHYBUS_ACCESS_TOKEN, authType } from '../../Configuration'
import { generateGUID } from '../../shared/utils/globalFunctions';
import { keycloak, keycloakGenerateSilentTokenIfExpired } from '../../authKeycloak';

interface AuthContextProviderrProps {
  children: React.ReactNode;
}
//To maintain the tokens
const defaultAuthContext = {
    accessToken: null,
    getAccessToken: () => {},
  };

const AuthContext = createContext(defaultAuthContext);

const AuthContextProvider: React.FC<AuthContextProviderrProps>  = ({ children }) => {
  const { instance, accounts } = useMsal();
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    const tokenRefreshInterval = setInterval(async () => {
      try {
        const token:any = await getAccessToken(); 
        setAccessToken(token);
         localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
        localStorage.setItem(RHYBUS_ACCESS_TOKEN,token)
        localStorage.setItem(CLIENT_CODE,APP_NAME)
      } catch (error) {
        console.error('Error refreshing access token:', error);
      }
    }, 60 * 60 * 1000); 
    return () => {
      clearInterval(tokenRefreshInterval);
    };

  }, [instance, accounts]); 

  const getAccessToken = async () => {
    if (authType.toLowerCase() === 'keycloak') {
      await keycloakGenerateSilentTokenIfExpired();
      setAccessToken(keycloak.token as any);
      localStorage.setItem(CLIENT_CODE, APP_NAME);
      return;
    }
    if (accounts.length === 0) return;
    const request:any = {
     ...loginRequest,
      account: accounts[0],
    };
    try {
      const response:any = await instance.acquireTokenSilent(request);
                setAccessToken(response.accessToken);
                localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
                   localStorage.setItem(RHYBUS_ACCESS_TOKEN, response.accessToken)
                localStorage.setItem(CLIENT_CODE,APP_NAME)
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const response:any = await instance.acquireTokenRedirect(request);
                   setAccessToken(response.accessToken);
                   localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
                   localStorage.setItem(RHYBUS_ACCESS_TOKEN, response.accessToken)
                   localStorage.setItem(CLIENT_CODE,APP_NAME)
        } catch (popupError) {
          console.error('Token acquisition failed', popupError);
        }
      } else {
        console.error('Token acquisition failed', error);
      }
    }
  };  

  useEffect( ()  => {
    getAccessToken();
    }
), [instance, accounts];

  return (
    <AuthContext.Provider value={{ accessToken, getAccessToken }}>
    {children}
  </AuthContext.Provider>
  );
  
}

export { AuthContext, AuthContextProvider }